import React from 'react';
import { Header, Paragraph, Section } from '../components/Typography';

const RegistrationComplete = () => (
  <Section>
    <Header>Congrats! You’re now registered!</Header>
    <Paragraph>
      We have sent you an email confirming your 14 day access to the boost.ai
      platform. There are more instructions in the email. Have fun learning and
      good luck!
    </Paragraph>
  </Section>
);

export default RegistrationComplete;
